import { useState } from "react";
import { Modal } from "react-bootstrap-v5"

type Props = {
    show: boolean;
    onClose: (value: boolean) => void;
}

export const MessageCancelationPolicy = ({ show, onClose }: Props) => {
    const [accepted, setAccepted] = useState(false);

    return (
        <Modal
            tabIndex='-1'
            dialogClassName="message-cancelation-policy-modal"
            contentClassName="message-cancelation-policy-modal-content"
            show={show}
        >
            <div className="d-flex flex-column w-100 align-items-start" style={{ gap: '40px' }}>
                <h5>Cancelation Policy</h5>
                <div className="d-flex flex-column w-100 align-items-start" style={{ gap: '30px' }}>
                    <div className="info-row">
                        <div>
                            <span>Within</span>
                            <p>24 hours of booking, - not less 30 days till experience</p>
                        </div>
                        <div>
                            <span>Partial refund</span>
                            <p>50% of refund</p>
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="511" height="1" viewBox="0 0 511 1" fill="none">
                        <path d="M0 0.5H511" stroke="#E9E9E9"/>
                    </svg>
                    <div className="info-row">
                        <div>
                            <span>After</span>
                            <p>Aug 7, 2:00 PM</p>
                        </div>
                        <div>
                            <span>Non refundable</span>
                            <p>Cancellations made later than 24 hours after booking (not less than 30 days left till Experience)  are not eligible for a refund</p>
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="511" height="1" viewBox="0 0 511 1" fill="none">
                        <path d="M0 0.5H511" stroke="#E9E9E9"/>
                    </svg>
                    <div className="d-flex flex-column align-items-start w-100" style={{ gap: '15px' }}>
                        <span className="subtitle">no reversal</span>
                        <div className="d-flex flex-row align-items-center justify-content-center w-100" style={{ padding: '10px', background: '#F5F5F5' }}>
                            <span className="body">Once cancelled, the action cannot be undone.</span>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-start w-100">
                        <span className="subtitle">cancelation reason</span>
                        <div className="d-flex w-100 justify-content-center align-items-center" style={{ padding: '15px 0', borderBottom: '1px solid var(--light-gray, #D7D7D7)' }}>
                            <input type="text" className="w-100 body" style={{ border: '0', outline: '0' }}/>
                        </div>
                        <span className="extra-info">Please provide a a reason for cancelation</span>
                    </div>

                    <div className="d-flex flex-row align-items-center" style={{ gap: '8px' }}>
                        <button onClick={() => setAccepted(prev => !prev)}>
                            {accepted ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <rect width="18" height="18" rx="2" fill="#460107"/>
                                    <path d="M14.3333 6L7.91667 12.4167L5 9.5" stroke="white" stroke-width="1.5"/>
                                </svg>
                            ):(
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <rect x="1" y="1" width="16" height="16" rx="1" stroke="#D7D7D7" stroke-width="2"/>
                                </svg>
                            )}
                        </button>
                        <span className="body">I agree to <a className="body" href="#">Nobilis Cancelation Terms & Conditions</a></span>
                    </div>

                    <div className="d-flex flex-row justify-content-between w-100">
                        <button className="btn-action-secundary" onClick={() => onClose(false)}>
                            Back
                        </button>
                        <button className="btn-action-primary" onClick={() => onClose(true)}>
                            Cancel invitation
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                                <path d="M8.5 0.382812L12 3.38696H0" stroke="white"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}